<template>
  <v-row class="mt-4">

    <v-col sm="4" class="pa-0">
      <v-card
          tile
      >
        <v-carousel
            hide-delimiter-background
            delimiter-icon="mdi-circle"
            height="auto"
            @change = 'getPage'
        >
          <v-carousel-item
              v-for="(photo, i) in plant.photos"
              :key="i"
          >
            <v-img
                :src="exhibitCompressedPhotoPath + `/${photo.compressedPhotoPath}`"
                position="center center"
                min-height="500px"
            >

            </v-img>
          </v-carousel-item>
        </v-carousel>
        <v-list two-line>
          <v-list-item>
            <v-list-item-content class="pa-0">
              <v-row class="ma-0">
                <v-btn block small text tile color="black">
                  <a target="_blank" :href="exhibitOriginPhotoPath + '/' + this.plant.photos[this.currentPage]?.fullPhotoPath.toString()"><p class="ma-0">Полное изображение</p></a>
                  <v-spacer/>
                </v-btn>
              </v-row>

              <v-row class="ma-0">
                <v-btn v-if="this.plant.species !== ''" @click="toAllExhibits" block small text tile color="primary">
                  <p class="ma-0">Все образцы вида</p>
                  <v-spacer/>
                </v-btn>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>

      <v-card v-if="isAdmin" tile class="mt-2">
        <v-list two-line>
          <v-list-item>
            <v-list-item-content class="pa-0">
              <v-row class="ma-0">
                <v-btn block text tile color="primary" @click="() => {
                  this.isUpdating = true
                  this.$vuetify.goTo(0)
                }">
                  Изменить экземпляр
                  <v-spacer/>
                </v-btn>
              </v-row>

              <v-row class="ma-0">
                <v-btn block text tile color="red" @click="() => this.isDeletion = true">
                  Удалить экземпляр
                  <v-spacer/>
                </v-btn>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>
<!-- Здесь начинается таблица, можно декомпозировать позже таблицу и карусель в разные компоненты -->
    <v-col sm="8" class="pa-0 pl-2">
      <v-card tile>
        <v-simple-table >
          <template v-slot:default>
            <tbody>
            <tr
                v-for="(item, index) in showingPlantMap"
                :key="index"
            >
              <td>{{ item[0] }}</td>
              <td>{{ item[1] }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>
    <!-- четыре нижних карточки -->
    <v-row class="ma-0 mt-5 mb-5">
      <v-col sm="6" class="pa-0">
        <v-card height="50%" tile class="pl-2">
          <div>
            Ссылка на образец
            <v-tooltip right color="white">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="copyPageLink">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span class="color-secondary font-weight-bold">Скопировать ссылку на образец</span>
            </v-tooltip>
          </div>
        </v-card>
        <v-card height="50%" tile class="pl-2">
          <div>
            Ссылка на скан
            <v-tooltip right color="white">
              <template v-slot:activator="{ on, attrs }">
                <v-btn  v-bind="attrs" v-on="on" icon @click="copyScanLink">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span class="color-secondary font-weight-bold">Скопировать ссылку на скан</span>
            </v-tooltip>
          </div>
        </v-card>
      </v-col>
      <v-col sm="6" class="pa-0">
        <v-card height="50%" tile class="pa-2">
          <div>Дата внесения: {{plant.addedDate}}</div>
        </v-card>
        <v-card height="50%" tile class="pa-2">
          <div>Образец внес: {{plant.submittedBy}}</div>
        </v-card>
      </v-col>
    </v-row>

    <ExhibitUpdate
        :show-modal="isUpdating"
        :plant="this.$props.plant"
        @drop-modal="() => this.isUpdating = false"
    />

    <v-dialog
        v-model="isDeletion"
        width="auto"
        persistent
        class="rounded-0"
    >
      <v-card class="pa-5 pt-10" tile>
        <p>Вы уверены что хотите удалить этот экземпляр?</p>
        <v-card-text>
          <div class="d-flex justify-end">
            <v-btn tile text color="red" @click="deleteThisExhibit">да</v-btn>
            <v-btn tile text color="blue accent-4" @click="() => this.isDeletion = false">нет</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>


</template>

<script>

import {deleteExhibit} from "@/services/exhibitAPI";
import ExhibitUpdate from "@/components/ExhibitPageComponents/ExhibitUpdate";
import {frontEndUrl, exhibitCompressedPhotoPath, exhibitOriginPhotoPath} from "@/helpers/siteURL";
import router from "@/router";
import { mergeStartAndEndDatesToString } from "@/helpers/datesUtil"

export default {
  name: "GeneralTab",
  components: {ExhibitUpdate},

  data () {
    return {
      currentPage: 0,
      showingPlantMap: new Map([]),
      frontEndUrl: frontEndUrl,
      exhibitCompressedPhotoPath: exhibitCompressedPhotoPath,
      exhibitOriginPhotoPath: exhibitOriginPhotoPath,
      url: frontEndUrl + this.$route.fullPath,

      isDeletion: false,
      isUpdating: false,
    }
  },

  props: {
    plant: {
      type: Object,
      required: true,
    }
  },

  methods: {
    getPage (i) {
      this.currentPage = i
    },

    toAllExhibits() {
      router.push(`/collections/${this.plant.id + '/' + this.plant.species}`)
    },

    getShowingSubsetProperties: (obj, ...keys) => Object.fromEntries(
        Object.entries(obj)
            .filter(([key]) => !keys.includes(key))
    ),

    copyPageLink () {
      try {
        navigator.clipboard.writeText(this.url)
      } catch (e) {
        throw e
      }
    },

    copyScanLink () {
      const string = this.plant.photos[this.currentPage]?.fullPhotoPath.toString()
      const path = exhibitOriginPhotoPath + `/${string}`
      try {
        navigator.clipboard.writeText(path)
      } catch (e) {
        throw e
      }
    },

    async deleteThisExhibit () {
      try {
        await deleteExhibit(this.$route.params.id)
      } catch (e) {
        console.log(e);
      } finally {
        await this.$router.push('/collections')
      }

    },
  },

  computed: {
    isAdmin() {
      return this.$store.getters.getIsViewAdminPanel;
    },

    parseDate() {
      const date = new Date(this.plant.addedDate)
      return `${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}.${(date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)}.${date.getFullYear()}`
    }
  },

  mounted() {
    this.showingPlantMap.set('Штрихкод', this.plant.barcode)
    this.showingPlantMap.set('Семейство', this.plant.family)
    this.showingPlantMap.set('Род', this.plant.genus)
    this.showingPlantMap.set('Вид', this.plant.species)
    this.showingPlantMap.set('Название на этикетке', this.plant.labelName)
    this.showingPlantMap.set('Название по Catalogue of Life', this.plant.taxonomy)
    if (this.plant.plantType === 'HIGHER_PLANT') { this.showingPlantMap.set('Название по POWO', this.plant.powotaxonomy) }
    this.showingPlantMap.set('Синонимы', this.plant.synonym)
    if (this.plant.plantType === 'HIGHER_PLANT') { this.showingPlantMap.set('Русское название', this.plant.russianName) }
    this.showingPlantMap.set('Текст этикетки', this.plant.labelText)
    this.showingPlantMap.set('Количество этикеток', this.plant.labelsCount)
    this.showingPlantMap.set('GPS-координаты, широта', this.plant.gps.latitude)
    this.showingPlantMap.set('GPS-координаты, долгота', this.plant.gps.longitude)
    this.showingPlantMap.set('Дата сбора', mergeStartAndEndDatesToString(this.plant.collectionDate.startDate, this.plant.collectionDate.endDate))
    this.showingPlantMap.set('Коллекторы', this.plant.collectors)
    this.showingPlantMap.set('Дата определения', mergeStartAndEndDatesToString(this.plant.determinationDate.startDate, this.plant.determinationDate.endDate))
    this.showingPlantMap.set('Детерминация', this.plant.determinatedBy)
    this.showingPlantMap.set('Природоохранный статус', this.plant.natureConservationStatus)
    if (this.plant.plantType === 'LICHEN') {
      this.showingPlantMap.set('Экологическая характеристика местообитания', this.plant.ecologicalCharacteristics)
      this.showingPlantMap.set('Примечание', this.plant.note)
    }
    this.showingPlantMap.set('Количество гербарных листов', this.plant.numberOfHerbariumSheets)
    this.showingPlantMap = Array.from(this.showingPlantMap)
  }
}

</script>

<style scoped>

</style>